import { render, staticRenderFns } from "./comms-settings.vue?vue&type=template&id=5d994582"
import script from "./comms-settings.vue?vue&type=script&lang=js"
export * from "./comms-settings.vue?vue&type=script&lang=js"
import style0 from "./comms-settings.vue?vue&type=style&index=0&id=5d994582&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports